import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  & + &:not(:first-child) {
    margin: 32px 0px 32px 0px;
    > div {
      margin-top: 24px;
    }
  }

  @media (max-width: 650px) {
    width: 100%;
  }
`;
